import { useEffect, useState } from "react";

import { RAIL_STACK_DURATION_MS } from "@/lib/railAnimation";

/**
 * Keeps children mounted briefly after `active` becomes false so exit
 * animations can finish (rail card mount wrappers).
 */
export function useRailPresence(
  active: boolean,
  durationMs: number = RAIL_STACK_DURATION_MS,
) {
  const [retain, setRetain] = useState(active);

  useEffect(() => {
    if (active) {
      setRetain(true);
      return;
    }
    const id = window.setTimeout(() => setRetain(false), durationMs);
    return () => window.clearTimeout(id);
  }, [active, durationMs]);

  return active || retain;
}
